import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Banner from "../../components/banner/banner";
import FormFrame from "../../components/form/form";
import "./register.css";
import { AuthContext } from "../../App";
import { putClinic, getUser } from "../../utils/api";
import { authentication } from "../../utils/config";
import FormUnit from "../../components/form/formUnit";
import mapping from "../../utils/areaMapping";

const Register = (props) => {
  
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);
  const [inputData, setInputData] = useState({
    clinicName: "",
    address: "",
    department: "",
    phone: "",
    area: "",
    id: "",
    hostName: "",
  });
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    console.log("conregi");
    let flag = true;
    /*
    if the sweetalert is true in auth check in the end of the function, 
    then the following function does noting
    */

    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (response.created === true) return navigate("/main");
      else if (response.data === "no user") return navigate("/email");
      else if (response.data === "no vertification") return navigate("/email");
      flag = false;
    };

    const fetchClinic = async () => {
      if (flag) return;
      const response = await getUser(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "發生錯誤",
          text: `${response.data}`,
          icon: "error",
        });
      } else {
        const jsonData = response.data;

        // first fill user personal info
        setInputData((prevData) => {
          const updatedData = {
            ...prevData,
            ["id"]: jsonData.clinic.id,
            ["hostName"]: jsonData.name,
          };
          console.log(updatedData);
          return updatedData;
        });
        // if the clinic hasn't created (meaning the first member of the clinic comes)
        if (!jsonData.clinic.isCreated) {
          setDisable(false);
        } else {
          // if the clinic has created, disable the address and name input cell, and fill with jsonData
          // find coresponding area chinese name
          setInputData((prevData) => {
            const updatedData = {
              ...prevData,
              ["area"]: jsonData.clinic.areaId,
              ["department"]: jsonData.clinic.department,
              ["phone"]: jsonData.clinic.phone,
              ["clinicName"]: jsonData.clinic.name,
              ["address"]: jsonData.clinic.address,
            };
            console.log(updatedData);
            return updatedData;
          });
        }
      }
    };

    const combined = async () => {
      await auth();
      await fetchClinic();
    };
    combined();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInputData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      console.log(updatedData);
      return updatedData;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const response = await putClinic(lineProfile, inputData, disable);
    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else {
      await Swal.fire({
        title: "註冊成功",
        text: "帳號註冊成功，現在享有更多服務!",
        icon: "success",
      });
      navigate(`/welcome?clinicName=${inputData.clinicName}`);
    }
  };

  const formData = [
    {
      title: "診所名稱",
      name: "clinicName",
      placeholder: "填寫完整診所名稱",
      required: true,
      value: inputData.clinicName,
      disabled: disable,
    },
    {
      title: "所屬單位(選填)",
      name: "department",
      placeholder: "",
      required: false,
      value: inputData.department,
      disabled: disable,
    },
    {
      title: "連絡電話",
      name: "phone",
      placeholder: "",
      required: true,
      value: inputData.phone,
      disabled: disable,
    },
  ];


  return (
    <>
      <Container
        fluid
        style={{ minHeight: "100vh", backgroundColor: "#E4F4F3" }}
      >
        <Row style={{ height: "12%" }}>
          <Banner />
        </Row>
        <Row>
          <div>
            <FormFrame
              title="會員註冊"
              formData={formData}
              submitTitle="下一步"
              handleSubmit={handleSubmit}
              handleChange={handleChange}
            >
              <div className="w-75 w-sm-50 mx-auto mt-3">
                <div className="w-100 w-sm-50 mx-auto register-form">
                  <Form.Label>
                    <b>地區</b>
                  </Form.Label>
                  <Form.Select
                    className="register-address-font"
                    aria-label="Default select example"
                    name="area"
                    onChange={handleChange}
                    disabled={disable}
                    value={inputData.area}
                  >
                    <option value="" disabled selected>
                      縣/市
                    </option>
                    <option value="TP">台北市</option>
                    <option value="NP">新北市</option>
                    <option value="JL">桃園市</option>
                    <option value="TY">桃園市</option>
                    <option value="YL">宜蘭縣</option>
                    <option value="HS">新竹市</option>
                    <option value="HX">新竹縣</option>
                    <option value="ML">苗栗縣</option>
                    <option value="TC">台中市</option>
                    <option value="NT">南投縣</option>
                    <option value="ZH">彰化縣</option>
                    <option value="YU">雲林縣</option>
                    <option value="CX">嘉義縣</option>
                    <option value="CS">嘉義市</option>
                    <option value="TN">台南市</option>
                    <option value="KH">高雄市</option>
                    <option value="PD">屏東縣</option>
                    <option value="HW">花蓮縣</option>
                    <option value="TD">台東縣</option>
                    <option value="KM">金門縣</option>
                    <option value="PH">澎湖縣</option>
                    <option value="LN">連江縣</option>
                    <option value="OT">其他地區</option>
                  </Form.Select>
                </div>
                <div className="w-100 w-sm-50 mx-auto register-form">
                  <Form.Group controlId="formName">
                    <Form.Label>
                      <b>聯絡地址</b>
                    </Form.Label>
                    <Form.Control
                      className="register-address-font"
                      name="address"
                      placeholder="請填寫地址"
                      required={true}
                      disabled={disable}
                      value={inputData.address}
                      index={5}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </div>
              </div>
            </FormFrame>
          </div>
        </Row>
        <div className="d-flex justify-content-center align-items-center w-50 m-auto mt-4">
          <Button className=" btn-custom-green w-100" onClick={handleSubmit}>
            確認
          </Button>
        </div>
      </Container>
    </>
  );
};

export default Register;
